import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import styles, { selectCustomStyles } from '../styles/availableNumbers';
import { reactSelectDefaultStyles } from '../../../consts/reactSelectDefaultStyles';
import { translate } from '../../../i18n/I18nProvider';

const AvailableNumbers = ({
  classes,
  availableNumbers,
  setSelectedNumber,
  isShortNumber = false,
  allNumbers = false,
  excludeNumbers = [],
  reduxAvailableNumbers
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const numbersToUse = availableNumbers || reduxAvailableNumbers || [];

  const handlePhoneNumberChange = selectedOptions => {
    setSelectedNumber(selectedOptions);
    setIsOpen(false);
  };

  const mappedAvailableNumbers = useMemo(() => {
    let filteredNumbers = numbersToUse;

    if (excludeNumbers.length > 0) {
      filteredNumbers = filteredNumbers.filter(
        number => !excludeNumbers.includes(number.value)
      );
    }

    if (allNumbers) {
      return filteredNumbers;
    }

    return filteredNumbers.reduce((acc, number) => {
      if (isShortNumber && number.value.length >= 8) {
        return acc;
      }
      if (!isShortNumber && number.value.length < 8) {
        return acc;
      }

      return [...acc, number];
    }, []);
  }, [numbersToUse, isShortNumber, allNumbers, excludeNumbers]);

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Dropdown
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          target={
            <div
              onClick={() => setIsOpen(prev => !prev)}
              className={classes.selectButton}
            >
              {translate('USER.SHOW_AVAILABLE_NUMBERS')}
            </div>
          }
        >
          <Select
            styles={reactSelectDefaultStyles}
            customStyles={selectCustomStyles}
            options={mappedAvailableNumbers}
            onChange={handlePhoneNumberChange}
            menuIsOpen={isOpen}
            controlShouldRenderValue={false}
            autoFocus
            maxMenuHeight={120}
            onBlur={() => setIsOpen(false)}
          />
        </Dropdown>
      </div>
    </div>
  );
};

const mapStatesToProps = ({ editUser }) => {
  const { availableNumbers, ...restEditUser } = editUser;
  return {
    ...restEditUser,
    reduxAvailableNumbers: availableNumbers
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(AvailableNumbers);

const Dropdown = ({ children, isOpen, target }) => (
  <div style={{ position: 'relative' }}>
    {target}
    {isOpen && (
      <div style={{ position: 'absolute', zIndex: 1000 }}>{children}</div>
    )}
  </div>
);
